import {
  FaCog,
  FaCoffee,
  FaMugHot,
  FaThermometerHalf,
  FaWater,
  FaBroom,
  FaWrench,
  FaSlidersH,
  FaLock,
  FaPalette,
} from "react-icons/fa";

// Profil kategorileri
export const PROFILE_CATEGORIES = {
  security: {
    title: "Güvenlik Ayarları",
    icon: FaLock,
    settings: [
      "userPassword",
      "adminPassword",
      "servicePassword",
      "developerPassword",
      "auth"
    ],
  },
  appearance: {
    title: "Görünüm Ayarları",
    icon: FaPalette,
    settings: ["bgColorChoose", "language"],
  },
  system: {
    title: "Sistem Ayarları",
    icon: FaCog,
    settings: ["errorCode"],
  },
};

// Label parsing fonksiyonu
export const parseLabel = (label) => {
  if (!label || typeof label !== "string") return "";

  // Başındaki belirli ifadeleri kaldır
  const trimmedLabel = label
    .replace(/^(Çay-Filtre Kahve|Türk Kahvesi|Çay)\s*/, "")
    .replace(/([A-Z])/g, " $1") // Büyük harflerden önce boşluk ekle
    .replace(/^./, (str) => str.toUpperCase()) // İlk harfi büyük yap
    .trim(); // Başındaki ve sonundaki boşlukları temizle

  return trimmedLabel;
};

// Genel ayarlar kategorilerini oluştur
export const categorizeGeneralSettings = (deviceName = "") => {
  // Cihaz ismini küçük harfe çevir ve kontrolleri yap
  const deviceNameLower = deviceName.toLowerCase();
  const hasTurkishCoffee = deviceNameLower.includes("fincanda");
  const hasTeaSet = deviceNameLower.includes("çayset");

  const categories = {
    // Çay ve Filtre Kahve ile ilgili ayarlar
    ...(hasTeaSet && {
      teaFilterBasic: {
        title: "Temel Çay ve Filtre Kahve Ayarları",
        icon: FaThermometerHalf,
        settings: [
          "heatValue",
          "waterTankDegree",
          "calibrationThreshold",
          "bottledTap",
          "halfKettle",
          "heater",
          "waterTankPumpMode",
          "waterTankMode",
          "waterTankActive",
          "trifaseMod",
          "potTankVolume",
          "massCalibrationThreshold",
          "brewMassInTheAir",
          "autoHeaterControlDegreeWithProgram",
          "autoHeaterOpenInterval",
        ],
      },
      teaSettings: {
        title: "Çay Ayarları",
        icon: FaWater,
        settings: [
          "referenceCup",
          "teaAbsurb",
          "teaServiceValue",
          "teaBrewing",
          "teaStaling",
        ],
      },
      filterCoffeeSettings: {
        title: "Filtre Kahve Ayarları",
        icon: FaCoffee,
        settings: [
          "filterAbsurb",
          "filterCoffeeServiceValue",
          "filterCoffeeBrewing",
          "filterCoffeeStaling",
          "filterCoffeeFirstWater",
          "filterCoffeeContinueWater",
          "filterCoffeeWaitingTime",
        ],
      },
      cleaningTeaSettings: {
        title: "Çay Temizlik Ayarları",
        icon: FaBroom,
        settings: ["cleaningEndCounterTea", "cleaningTimeTea"],
      },
      cleaningFilterCoffeeSettings: {
        title: "Filtre Kahve Temizlik Ayarları",
        icon: FaBroom,
        settings: [
          "cleaningEndCounterFilterCoffee",
          "cleaningTimeFilterCoffee",
        ],
      },
      cleaningSettings: {
        title: "Temizlik Ayarları",
        icon: FaBroom,
        settings: ["drain", "cleaning"],
      },
    }),

    // Türk Kahvesi ile ilgili ayarlar
    ...(hasTurkishCoffee && {
      turkishCoffeeBasic: {
        title: "Türk Kahvesi Temel Ayarları",
        icon: FaCoffee,
        settings: [
          "firstWater",
          "firstMixerTime",
          "maxCookingTime",
        ],
      },
      turkishCoffeeWaterDraw: {
        title: "Türk Kahvesi Su Çekme Ayarı",
        icon: FaCoffee,
        settings: ["waterStorageFillingTime", "mainWater"],
      },
      turkishCoffeeMill: {
        title: "Türk Kahvesi Öğütücü Ayarları",
        icon: FaWrench,
        settings: [
          "millTime_0",
          "millTime_1",
          "millTimeout",
          "millWaitingTime",
          "defaultMill",
          "grinder"
        ],
      },
      turkishCoffeeCleaning: {
        title: "Türk Kahvesi Temizlik Ayarları",
        icon: FaBroom,
        settings: [
          "cleaningTemperature",
          "cleaningTimeTurkishCoffee",
          "cleaningEndCounterTurkishCoffee",
        ],
      },
    }),
  };

  return categories;
};

// Göz ayarları kategorilerini oluştur (Çay)
export const categorizePotTeaSettings = (deviceName = "") => {
  const deviceNameLower = deviceName.toLowerCase();
  const hasTeaSet = deviceNameLower.includes("çayset");

  const customCategories = {
    // Çay ve Filtre Kahve Özelleştirme Ayarları
    ...(hasTeaSet && {
      teaFilterCoffeeCalibration: {
        title: "Çay & Filtre Kahve Kalibrasyon Ayarları",
        icon: FaSlidersH,
        settings: ["potCalibrationTime", "massScale"],
      },
    }),
  };

  return Object.values(customCategories).flat();
};

// Göz ayarları kategorilerini oluştur (Türk Kahvesi)
// Pişirme ayarları (cookingTemperature, halfPower*, mixerSpeed, serviceDown,
// firstWater, firstMixerTime, maxCookingTime, fullPowerMode) ve waterLevel_0/_1
// cups[] matrisine taşındı; BrewingSettingsMatrix component'i render eder.
export const categorizePotTurkishCoffeeSettings = (deviceName = "") => {
  const deviceNameLower = deviceName.toLowerCase();
  const hasTurkishCoffee = deviceNameLower.includes("fincanda");

  const customCategories = {
    ...(hasTurkishCoffee && {
      turkishCoffeeCupSettings: {
        title: "Türk Kahvesi Fincan Ayarları",
        icon: FaMugHot,
        settings: [
          "cleaningWaterLevel",
          "cupDisabled",
          "cupAlready",
        ],
      },
    }),
  };

  return Object.values(customCategories).flat();
};
